import { forwardRef, memo } from "react";

export const UserSquareIcon = memo(
  forwardRef(function UserSquareIcon(
    { size = 26, color = "currentColor", title, className, ...rest },
    ref,
  ) {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={title ? undefined : true}
        focusable="false"
        className={className}
        {...rest}
      >
        {title ? <title>{title}</title> : null}
        <path
          d="M14.1543 21.4683H8.49234C7.24671 21.4683 6.20868 21.3456 5.33108 21.0814C5.01023 20.9871 4.80263 20.6756 4.8215 20.3453C5.05742 17.5238 7.91671 15.3062 11.3233 15.3062C14.7299 15.3062 17.5798 17.5143 17.8252 20.3453C17.8535 20.6851 17.6459 20.9871 17.3156 21.0814C16.438 21.3456 15.4 21.4683 14.1543 21.4683ZM6.3408 19.8735C6.96361 19.9962 7.67136 20.0528 8.49234 20.0528H14.1543C14.9753 20.0528 15.683 19.9962 16.3059 19.8735C15.8057 18.0617 13.7391 16.7216 11.3233 16.7216C8.90756 16.7216 6.84094 18.0617 6.3408 19.8735Z"
          fill={color}
        />
        <path
          d="M14.1543 1.88733H8.49235C3.77404 1.88733 1.88672 3.77465 1.88672 8.49296V14.1549C1.88672 17.722 2.96249 19.6754 5.52925 20.402C5.73686 17.9485 8.25644 16.0139 11.3233 16.0139C14.3902 16.0139 16.9098 17.9485 17.1174 20.402C19.6842 19.6754 20.76 17.722 20.76 14.1549V8.49296C20.76 3.77465 18.8726 1.88733 14.1543 1.88733ZM11.3233 13.3717C9.45489 13.3717 7.94503 11.8524 7.94503 9.98397C7.94503 8.11551 9.45489 6.60564 11.3233 6.60564C13.1918 6.60564 14.7017 8.11551 14.7017 9.98397C14.7017 11.8524 13.1918 13.3717 11.3233 13.3717Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.3243 14.0794C9.06899 14.0794 7.23828 12.2393 7.23828 9.9839C7.23828 7.72855 9.06899 5.89783 11.3243 5.89783C13.5797 5.89783 15.4104 7.72855 15.4104 9.9839C15.4104 12.2393 13.5797 14.0794 11.3243 14.0794ZM11.3243 7.31332C9.85223 7.31332 8.65377 8.51179 8.65377 9.9839C8.65377 11.4654 9.85223 12.6639 11.3243 12.6639C12.7965 12.6639 13.9949 11.4654 13.9949 9.9839C13.9949 8.51179 12.7965 7.31332 11.3243 7.31332Z"
          fill={color}
        />
      </svg>
    );
  }),
);

UserSquareIcon.displayName = "UserSquareIcon";